'use strict';

const Effects = (($) => {

    const NAME = 'effects';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class Effects {

        // totalWidth = 0;

        $element = false;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;

            this.triggerDistance = 100;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            $('body').append('<div class="page-transition"></div>');

            $('.js-project-data').addClass('loaded');

            this.elements = this.$element.find('.anim');

            this.elements.each(function() {
                console.log($(this).attr('class'));
            //     if ($(this).hasClass('mod_article')) {
            //         $(this).find('.ce_image, .ce_text').parent().addClass('anim-container');
            //         $(this).find('.ce_image, .ce_text').addClass('anim-target');
            //
            //         $(this).find('.ce_image, .ce_text').each(function(i) {
            //             $(this).addClass('anim-target--' + i);
            //         });
            //     }
            });

            // this.containers = this.$element.find('.anim-container');
            this.articleContainers = $('body').find('.anim-all');
            // this.targets = this.$element.find('.anim-target');
        }

        addEventListeners() {
            var _self = this;

            _self.checkViewport();

            $(window).on('load scroll', function(e) {
                console.log('check');
                _self.checkViewport();
            });

            $('.transition-link').on('click', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');

                // $('body').append('<div class="page-transition"></div>');
                $('.page-transition').addClass('active');

                if ($(this).hasClass('transition-link--black')) {
                    $('.page-transition').addClass('black');
                }

                if ($(this).hasClass('transition-link--grey')) {
                    $('.page-transition').addClass('grey');
                }

                // console.log('clicked');
                setTimeout(function () {
                    // console.log('continue');
                    window.location = href;
                }, 700)
            });

            $('.has-transition-link a').on('click', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');

                // $('body').append('<div class="page-transition"></div>');
                $('.page-transition').addClass('active');

                if ($(this).parents('.has-transition-link').hasClass('has-transition-link--black')) {
                    console.log('black');
                    $('.page-transition').addClass('black');
                }

                if ($(this).parents('.has-transition-link').hasClass('has-transition-link--grey')) {
                    $('.page-transition').addClass('grey');
                }

                // console.log('clicked');
                setTimeout(function () {
                    // console.log('continue');
                    window.location = href;
                }, 700)
            });
        }

        isElementInViewport(element) {
            var rect = element.getBoundingClientRect();
            // console.log(rect.top - window.innerHeight);

            var viewportHeight = (window.innerHeight || document.documentElement.clientHeight);

            return (
                (rect.top - viewportHeight) < -1 * this.triggerDistance
            );
            // return (
            //     // rect.top >= 0 &&
            //     // rect.left >= 0 &&
            //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            // );
        }

        // function hasEnteredViewport(element, triggerDistance = 0) {
        //     var rect = element.getBoundingClientRect();
        //     return (
        //         (rect.top + triggerDistance) <= (window.innerHeight || document.documentElement.clientHeight)
        //     );
        // }

        checkViewport() {
            // for (var i = 0; i < this.containers.length; i++) {
            //     if (this.isElementInViewport(this.containers[i])) {
            //         $(this.containers[i]).addClass("in-viewport");
            //     }
            // }
            for (var i = 0; i < this.elements.length; i++) {
                if (this.isElementInViewport(this.elements[i])) {
                    $(this.elements[i]).addClass("in-viewport");
                }
            }

            for (var i = 0; i < this.articleContainers.length; i++) {
                if (this.isElementInViewport(this.articleContainers[i])) {
                    var article = $(this.articleContainers[i]);

                    article.addClass("in-viewport");
                    setTimeout(function () {
                        article.removeClass('anim-all');
                    }, 1000)
                }
            }
        }

        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    Effects.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new Effects(this, _config)
            })
        }
    }

    $.fn[NAME] = Effects._jQueryInterface;
    $.fn[NAME].Constructor = Effects;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Effects._jQueryInterface
    };

    return Effects;

})(jQuery);

export default Effects;